export const ItemTypes = {
  MENU_ITEM: "menu-item",
  MENU_NOTE: "menu-note",
  RECIPE_IN_SECTION: "recipe-in-section"
};
